(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[361,8390],{

/***/ 91013:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/redeem/[[...promocode]]",
      function () {
        return __webpack_require__(49717);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ PageWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_dark_mode_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68366);







var Header = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
        return [
            2,
            Promise.all(/* import() */[__webpack_require__.e(8579), __webpack_require__.e(9800)]).then(__webpack_require__.bind(__webpack_require__, 59800))
        ];
    });
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59800)
            ];
        }
    }
});
var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
        return [
            2,
            Promise.all(/* import() */[__webpack_require__.e(8579), __webpack_require__.e(3878), __webpack_require__.e(5822)]).then(__webpack_require__.bind(__webpack_require__, 17909))
        ];
    });
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17909)
            ];
        }
    }
});
var PageWrapper = function(param) {
    var children = param.children, hideHeader = param.hideHeader, hideFooter = param.hideFooter, headerProps = param.headerProps, mainLayoutStyle = param.mainLayoutStyle, innerWebStyle = param.innerWebStyle;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var innerWebQP = Boolean(Number(router.query.innerweb));
    var darkModeQP = Boolean(Number(router.query.dark_mode));
    var isDarkModeEnabled = (0,_helpers_dark_mode_helper__WEBPACK_IMPORTED_MODULE_6__/* .shouldEnableDarkMode */ .N)(router.pathname, darkModeQP);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "page-wrapper ".concat(innerWebQP && "inner-web", " ").concat(isDarkModeEnabled ? "dark-mode" : ""),
        style: innerWebQP ? innerWebStyle : null,
        children: [
            hideHeader || innerWebQP ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Header, {
                headerProps: headerProps
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "main-layout ".concat(innerWebQP || (headerProps === null || headerProps === void 0 ? void 0 : headerProps.shouldStartTransparent) ? "" : "header-padding"),
                style: mainLayoutStyle,
                children: children
            }),
            hideFooter || innerWebQP ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {})
        ]
    });
};


/***/ }),

/***/ 18390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WhiteBox": function() { return /* binding */ WhiteBox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _whitebox_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29881);
/* harmony import */ var _whitebox_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_whitebox_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var WhiteBox = function(param) {
    var children = param.children, wrapperStyle = param.wrapperStyle, customStyle = param.customStyle, customClass = param.customClass;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_whitebox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().wrapperBox), " wrapperBox"),
        style: wrapperStyle,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_whitebox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().whiteBox), " whiteBox ").concat((_whitebox_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[customClass]),
            style: customStyle,
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (WhiteBox);


/***/ }),

/***/ 49717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Promocode": function() { return /* binding */ Promocode; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _promocode_; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/pagewrapper/pagewrapper.tsx
var pagewrapper = __webpack_require__(96213);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(65218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/redeem/redeem.module.scss
var redeem_module = __webpack_require__(93570);
var redeem_module_default = /*#__PURE__*/__webpack_require__.n(redeem_module);
// EXTERNAL MODULE: ./helpers/analytics.ts + 4 modules
var analytics = __webpack_require__(34420);
// EXTERNAL MODULE: ./components/white-box/whitebox.tsx
var whitebox = __webpack_require__(18390);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(93434);
// EXTERNAL MODULE: ./helpers/helper.ts
var helper = __webpack_require__(19181);
// EXTERNAL MODULE: ./components/auth/auth.context.ts
var auth_context = __webpack_require__(29873);
// EXTERNAL MODULE: ./enums/utils-constants.ts
var utils_constants = __webpack_require__(18821);
// EXTERNAL MODULE: ../node_modules/next/dist/compiled/timers-browserify/main.js
var main = __webpack_require__(92220);
;// CONCATENATED MODULE: ./components/redeem/redeem.tsx














var AMPLITUDE_EVENTS = {
    ANON_USER: "redeem - anon user"
};
var RedeemInputBox = dynamic_default()(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        return [
            2,
            __webpack_require__.e(/* import() */ 5690).then(__webpack_require__.bind(__webpack_require__, 15690))
        ];
    });
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15690)
            ];
        }
    }
});
var RedeemCard = dynamic_default()(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        return [
            2,
            __webpack_require__.e(/* import() */ 5446).then(__webpack_require__.bind(__webpack_require__, 95446))
        ];
    });
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95446)
            ];
        }
    }
});
var GiftBox = dynamic_default()(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        return [
            2,
            Promise.all(/* import() */[__webpack_require__.e(8579), __webpack_require__.e(3583)]).then(__webpack_require__.bind(__webpack_require__, 37066))
        ];
    });
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37066)
            ];
        }
    }
});
var LoginBox = dynamic_default()(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        return [
            2,
            __webpack_require__.e(/* import() */ 712).then(__webpack_require__.bind(__webpack_require__, 50712))
        ];
    });
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50712)
            ];
        }
    }
});
var Benefits = dynamic_default()(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        return [
            2,
            Promise.all(/* import() */[__webpack_require__.e(8579), __webpack_require__.e(689)]).then(__webpack_require__.bind(__webpack_require__, 70689))
        ];
    });
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(70689)
            ];
        }
    }
});
var Redeem = function(param) {
    var promocode = param.promocode, autoload = param.autoload, isMobile = param.isMobile, isDarkMode = param.isDarkMode, urlParams = param.urlParams;
    var user = (0,react.useContext)(auth_context/* userContext */.x).user;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(null), renderedComponent = ref[0], setRenderedComponent = ref[1];
    var ref1 = (0,react.useState)(autoload || false), shouldHideHeader = ref1[0], setShouldHideHeader = ref1[1];
    (0,react.useEffect)(function() {
        if ((user || isMobile) && (0,helper/* isBrowser */.jU)()) {
            setRenderedComponent(renderInitialRedeem);
        } else {
            var _props = {
                utm_source: urlParams.utm_source || "organic",
                utm_medium: urlParams === null || urlParams === void 0 ? void 0 : urlParams.utm_medium,
                utm_campaign: urlParams === null || urlParams === void 0 ? void 0 : urlParams.utm_campaign
            };
            (0,main.setTimeout)(function() {
                (0,analytics/* default */.ZP)(AMPLITUDE_EVENTS.ANON_USER, _props);
            }, 100);
            setRenderedComponent(renderLoginBox);
        }
    }, [
        user
    ]);
    var giftBoxComponent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "gift-wrap-margin ".concat((redeem_module_default())["gift-wrap-margin"]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftBox, {})
        });
    };
    var renderExtras = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: giftBoxComponent()
        });
    };
    var renderLoginBox = function() {
        if ((0,helper/* isBrowser */.jU)()) {
            setShouldHideHeader(false);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(whitebox.WhiteBox, {
                        customStyle: {
                            marginTop: "-5rem"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginBox, {
                            title: "login_to_continue",
                            cta: "login",
                            classes: "green"
                        })
                    }),
                    renderExtras()
                ]
            });
        }
        return null;
    };
    var renderMobileCard = function(_data) {
        if ((0,helper/* isBrowser */.jU)()) {
            setShouldHideHeader(true);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RedeemCard, {
                        data: _data,
                        isDarkMode: isDarkMode,
                        urlParams: urlParams
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Benefits, {
                        showDescription: false,
                        type: "square",
                        subtitle: t("redeem_plus_features_title"),
                        features: utils_constants/* ANGHAMI_PLUS_BENEFITS */.UC,
                        color: "#4EE5B1",
                        imgSize: 40
                    })
                ]
            });
        }
        return null;
    };
    var reEvaluateComponent = function(_data) {
        if (_data === null || _data === void 0 ? void 0 : _data.error) {
            setShouldHideHeader(false);
        } else {
            setRenderedComponent(renderMobileCard(_data));
        }
    };
    var renderInitialRedeem = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RedeemInputBox, {
                    promocode: promocode,
                    isMobile: isMobile,
                    isDarkMode: isDarkMode,
                    isLoggedIn: Boolean(user),
                    urlParams: urlParams,
                    onSubmitResponse: function(_e) {
                        reEvaluateComponent(_e);
                    }
                }),
                !autoload ? renderExtras() : null
            ]
        });
    };
    var renderHeader = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((redeem_module_default())["redeem-header"], " flexbox ").concat(isMobile ? "start ".concat((redeem_module_default()).mobile) : "centered"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((redeem_module_default())["redeem-header-title"], " bold"),
                children: t("redeem_header_title")
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            shouldHideHeader ? null : renderHeader(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (redeem_module_default()).RedeemWrapper,
                children: renderedComponent
            })
        ]
    });
};
Redeem.propTypes = {
    promocode: (prop_types_default()).string,
    isMobile: (prop_types_default()).bool
};
/* harmony default export */ var redeem = (Redeem);

// EXTERNAL MODULE: ./components/auth/index.tsx + 2 modules
var auth = __webpack_require__(92119);
;// CONCATENATED MODULE: ./pages/redeem/[[...promocode]].tsx






var __N_SSP = true;
// TODO: add SEO
var Promocode = function(param) {
    var query = param.query, isDesktop = param.isDesktop;
    var promocode = query.promocode, autoload = query.autoload;
    var isDarkMode = Boolean(Number(query === null || query === void 0 ? void 0 : query.dark_mode));
    if (promocode && typeof promocode !== "string") {
        promocode = promocode[0];
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pagewrapper/* PageWrapper */.F, {
        hideHeader: false,
        hideFooter: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(redeem, {
            isDarkMode: isDarkMode,
            isMobile: !isDesktop,
            promocode: promocode,
            autoload: autoload,
            urlParams: query
        })
    });
};
Promocode.propTypes = {
    query: (prop_types_default()).any,
    isDesktop: (prop_types_default()).bool
};
/* harmony default export */ var _promocode_ = ((0,auth/* default */.Z)(Promocode));


/***/ }),

/***/ 93570:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"redeem_d-flex__WjIBk","f-column":"redeem_f-column__HDPTU","f-justify-center":"redeem_f-justify-center__Sw0eo","f-justify-between":"redeem_f-justify-between__VMkeh","f-justify-start":"redeem_f-justify-start__p_iQ3","f-justify-end":"redeem_f-justify-end__LWIeb","f-align-center":"redeem_f-align-center__K8WyS","f-align-start":"redeem_f-align-start__xkbE6","f-align-stretch":"redeem_f-align-stretch__NXMSp","f-align-end":"redeem_f-align-end__ZrcV_","f-center":"redeem_f-center__lTdk4","position-relative":"redeem_position-relative__tYPmr","w-100":"redeem_w-100__ETn13","redeem-header":"redeem_redeem-header__0P_UN","redeem-header-title":"redeem_redeem-header-title__gXWcX","mobile":"redeem_mobile__P8_sI","redeem-header-img":"redeem_redeem-header-img__Tzdz0","main-loader":"redeem_main-loader__Om_vR","faq-wrapper":"redeem_faq-wrapper__I533T","content":"redeem_content__fhjWP","gift-wrap-margin":"redeem_gift-wrap-margin__isASR","RedeemWrapper":"redeem_RedeemWrapper__ksg6V","sponsored-partners-wrapper":"redeem_sponsored-partners-wrapper__tQq9R"};

/***/ }),

/***/ 29881:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"whitebox_d-flex__qO2m1","f-column":"whitebox_f-column__zsXh_","f-justify-center":"whitebox_f-justify-center__EGBkC","f-justify-between":"whitebox_f-justify-between__Y6Qkz","f-justify-start":"whitebox_f-justify-start__LfC0M","f-justify-end":"whitebox_f-justify-end__C_q9K","f-align-center":"whitebox_f-align-center__mCEke","f-align-start":"whitebox_f-align-start__zdF5k","f-align-stretch":"whitebox_f-align-stretch__O9IdY","f-align-end":"whitebox_f-align-end__IriCA","f-center":"whitebox_f-center__m2ACL","position-relative":"whitebox_position-relative__5gdvm","w-100":"whitebox_w-100___GQKe","whiteBox":"whitebox_whiteBox__ekbhI","darkMode":"whitebox_darkMode__Oa3Mn","wrapperBox":"whitebox_wrapperBox__JTSon","telco_container":"whitebox_telco_container__O8H1b"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7953,5490,8426,2119,8821,9774,2888,179], function() { return __webpack_exec__(91013); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);